

import BaseStore from "./BaseStore";
import ActionResultEvents from "../constants/events/ActionResultEvents";

class SecureBaseStore extends BaseStore {

    constructor(storeUpdateEvent, stateBuilderClass) {
        super(storeUpdateEvent, stateBuilderClass);
        this.subscribeToEvent(ActionResultEvents.FB_LOGOUT_SUCCESS, this.resetStore);
        this.subscribeToEvent(ActionResultEvents.INVALID_SESSION, this.resetStore)
    }


}
export default SecureBaseStore;